/**
 * Currencies a user can keep their budget in — mirrors src/config/currencies.ts
 * (backend). Amounts are stored ×100 in any currency; changing the currency
 * relabels them, it does not convert.
 */
export const SUPPORTED_CURRENCIES = [
  'EUR', 'USD', 'GBP', 'CHF', 'CAD', 'AUD', 'NZD', 'JPY', 'SEK', 'NOK', 'DKK', 'PLN', 'CZK', 'HUF', 'SGD', 'HKD', 'ZAR', 'BRL', 'MXN',
] as const;
export type Currency = (typeof SUPPORTED_CURRENCIES)[number];

export const DEFAULT_CURRENCY: Currency = 'EUR';

/** "Euro (EUR)" in the UI language; the code alone where the browser has no names. */
export function currencyLabel(currency: Currency, language: string): string {
  try {
    const name = new Intl.DisplayNames([language], { type: 'currency' }).of(currency);
    return name && name !== currency ? `${name} (${currency})` : currency;
  } catch {
    return currency;
  }
}
